
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexO8P0X8mWxb2hIT9I5iEF7mC0ITYsQ9e0cQYvu8h2uqkMeta } from "/tmp/tmp58hsgh0h/pages/[area]/[pref]/[id]/index.vue?macro=true";
import { default as indexXyteiQlwbLXxWJMfpcLZnhoeHBaCEOzzSFTI1KwjSm8Meta } from "/tmp/tmp58hsgh0h/pages/[area]/[pref]/index.vue?macro=true";
import { default as indexCFZmRZhAz21TMrmW_9X7KSv57gfSDPSSMeQ5YIoQQtkMeta } from "/tmp/tmp58hsgh0h/pages/[area]/index.vue?macro=true";
import { default as indexazMpI41TE0Aoe1f_Y9ul6VkCt7JIbqb844h6piCgq0cMeta } from "/tmp/tmp58hsgh0h/pages/index.vue?macro=true";
import { default as indexcQIfCV2FMeCAiW88y5JY41ubu9L8uvey9RTwVDtxjlwMeta } from "/tmp/tmp58hsgh0h/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexGypKjhpUr_B_Omg_gOYau_45SalQSEO9LrcEiJTD_unmMMeta } from "/tmp/tmp58hsgh0h/pages/okinawa/index.vue?macro=true";
import { default as indexvYDNm_45djAWoLIDY1S7Y4iivdYsn5NKBFlODcKCYW_9cMeta } from "/tmp/tmp58hsgh0h/pages/zoom-map/index.vue?macro=true";
export default [
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmp58hsgh0h/pages/[area]/[pref]/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmp58hsgh0h/pages/[area]/[pref]/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmp58hsgh0h/pages/[area]/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmp58hsgh0h/pages/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmp58hsgh0h/pages/okinawa/[id]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmp58hsgh0h/pages/okinawa/index.vue")
  },
  {
    name: "zoom-map",
    path: "/zoom-map",
    component: () => import("/tmp/tmp58hsgh0h/pages/zoom-map/index.vue")
  }
]